var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldAlignVertically(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6 19.25c-1.5 0-2.1-.64-2.1-2.23v-1.04c0-1.59.6-2.23 2.1-2.23h10.8c1.5 0 2.1.64 2.1 2.23v1.04c0 1.59-.6 2.23-2.1 2.23H6.6z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.25V18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 21.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2h1.5v2z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.75v3h-1.5v-3h1.5z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75V6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.25h-1.5v-2.5c0-.41.34-.75.75-.75s.75.34.75.75v2.5zM8.6 10.75c-1.5 0-2.1-.64-2.1-2.23V7.48c0-1.59.6-2.23 2.1-2.23h6.8c1.5 0 2.1.64 2.1 2.23v1.04c0 1.59-.6 2.23-2.1 2.23H8.6z",
    fill: "#292D32",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAlignVertically);
export default __webpack_public_path__ + "static/media/vuesax-bold-align-vertically.636f7f1e78545aa687f4164f32b59a80.svg";
export { ForwardRef as ReactComponent };